import { DentallyWizardService } from 'src/app/components/wizards/dentally/dentally-wizard.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { LaunchButtonDialogComponent } from './launch-button-dialog/launch-button-dialog.component';
import { AuthService } from 'src/auth/auth.service';
import { ClaimValue } from 'src/core/enums/auth/ClaimValue';
import { ClaimCategory } from 'src/core/enums/auth/ClaimCategory';
import { ClaimSubCategory } from 'src/core/enums/auth/ClaimSubCategory';

@Component({
  selector: 'launch-button',
  templateUrl: './launch-button.component.html',
  styleUrls: ['./launch-button.component.scss']
})
export class LaunchButtonComponent implements OnInit {
  isActive=false;

  constructor(private dialog: MatDialog, private auth: AuthService, private dentallyService:DentallyWizardService) { }

  ngOnInit() {
        this.dentallyService.islaunchButtonActive()
        .subscribe(status=>{
           this.isActive=status;
        });
  }

  onLaunchClick(){
    var ref = this.dialog.open(LaunchButtonDialogComponent);
  }

  get showLaunchButton(): boolean {
    const hasPermission = this.auth.hasPermissionCenter("",
                                                        ClaimValue.Name("Update"),
                                                        ClaimCategory.Name("OrganizationWizard"),
                                                        ClaimSubCategory.Name("All"))
    return hasPermission 
           && this.isActive;
  } 

}
